module.exports = __webpack_public_path__ + "img/sfeerfoto2.315ea417.jpg";